/**
 * Invokes setTimeout as a promise
 * @param ms The number of milliseconds to delay
 */
export function delay(ms: number): Promise<void> {
    return new Promise((resolve, reject) => setTimeout(() => { resolve(); }, ms));
}

/**
 * Converts a JQuery $.Deferred into a standard Promise
 * @param deferred The JQuery promise to wrap
 */
export function standardize<T>(deferred: JQueryPromise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
        deferred.then(resolve, reject);
    });
}
